import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AboutUs } from "@/components/AboutUs";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-parchment">
      <Navbar />
      <main className="pt-20">
        <section className="py-24 bg-parchment border-b-2 border-ink">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-6 block">Nuestra Historia</span>
              <h1 className="text-6xl md:text-8xl font-display font-black uppercase italic leading-none mb-8 text-ink">
                Tres Visiones, <br /> <span className="text-stroke-ink text-parchment">Un Mismo Destino</span>
              </h1>
              <p className="text-2xl font-serif italic text-ink/70 leading-relaxed max-w-2xl">
                Nacimos de la necesidad de profesionalizar y potenciar al corredor independiente, uniendo la experiencia del campo con la potencia de la tecnología.
              </p>
            </div>
          </div>
        </section>
        <AboutUs />
      </main>
      <Footer />
    </div>
  );
}
